import React from "react";
import { useDrop } from "react-dnd";
import { Box, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { PropTypes } from "prop-types";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  dropTarget: {
    ...theme.mixins.dashedBorder,
    minHeight: 72,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: theme.palette.text.disabled
  },
  isDragging: {
    backgroundColor: theme.palette.action.hover
  },
  isOver: {
    backgroundColor: theme.palette.primary.light
  },
  disabled: {
    backgroundColor: theme.palette.action.disabledBackground
  }
}));

const DraggableItemDropTarget = ({
  draggableItemTypes,
  isDraggingItem,
  disabled,
  onDropItem
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [{ isOver }, dropRef] = useDrop(() => ({
    accept: draggableItemTypes,
    collect: monitor => ({
      isOver: monitor.isOver()
    }),
    canDrop: () => !disabled,
    drop: item => {
      onDropItem(item);
    }
  }));
  return (
    <div ref={dropRef}>
      <Box
        className={clsx(classes.dropTarget, {
          [classes.isDragging]: isDraggingItem,
          [classes.isOver]: isOver,
          [classes.disabled]: disabled
        })}
        minHeight={72}
        p={2.5}
      >
        <Typography>{t("draggableItemDropTarget.dropMessage")}</Typography>
      </Box>
    </div>
  );
};

export default DraggableItemDropTarget;

DraggableItemDropTarget.propTypes = {
  /**
   * Called when the user presses the enter key on the search input box, clicks on one of the starting letter options,
   * or clicks on the "Filter List" button
   */
  onApplyFilters: PropTypes.func,
  onDropItem: PropTypes.func,
  disabled: PropTypes.bool,
  draggableItemTypes: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
};
